import { CSSProperties } from 'react'

const styles = {
  container: {},

  section: {
    marginBottom: 4,
    '&:last-child': { marginBottom: 0 }
  },

  sectionTitle: {
    marginBottom: 2,
    fontWeight: 'medium',
    color: 'text.primary'
  },

  flightDetailsHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 1
  },

  flightDetailsTitleContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: 1.5
  },

  flightDetailsTitleText: {
    fontWeight: 600
  },

  editedChip: {
    borderColor: '#9CA3AF',
    color: '#6B7280',
    fontSize: '0.75rem',
    height: 24
  },

  flightDetailsButtonGroup: {
    display: 'flex',
    gap: 1
  },

  flightDate: {
    fontWeight: 'medium'
  },

  legContainer: {
    marginBottom: 2,
    '&:last-child': { marginBottom: 0 }
  },

  legSection: {
    padding: 2,
    border: '1px solid',
    borderColor: 'divider',
    borderRadius: 1
  },

  airlineInfo: {
    display: 'flex',
    alignItems: 'center',
    gap: 1.5
  },

  airlineLogo: {
    width: 20,
    height: 20,
    objectFit: 'contain'
  } as CSSProperties,

  divider: {
    marginTop: 2,
    marginBottom: 2,
    borderColor: 'divider'
  },

  skeletonContainer: {},

  skeletonItem: {
    marginBottom: 3,
    borderRadius: 2
    // '&:last-child': { marginBottom: 0 }
  }
}

export default styles
